// extracted by mini-css-extract-plugin
module.exports = {"bgWrapper":"layout-module--bgWrapper--2OgKm","pageWrapper":"layout-module--pageWrapper--3WqFy","mobileBgWrapper":"layout-module--mobileBgWrapper--2ugSB"};